import { CommunityAnnouncements, Users } from '@platform/client';
import { CommunityHomeBanner } from './CommunityHomeBanner';
import { CommunityHomeMobileBanner } from './CommunityHomeMobileBanner';
import { AdvisorCard } from './CommunitySidebar/AdvisorCard/AdvisorCard';
import { CommunityAnnouncementCard } from './CommunitySidebar/CommunityAnnouncementCard';
import { NetworkCard } from './CommunitySidebar/NetworkCard';
import { CommunityWinsCarousel } from './CommunityWinsCarousel/CommunityWinsCarousel';
import { EventsSegment } from './EventsSegment';
import { FundingOpportunitySegment } from './FundingOpportunitySegment';
import { JobPostingsSegment } from './JobOpeningsSegment';

export const CommunityHomePage = () => {
  const user = Users.useGetCurrentUser();

  const isRepresentative =
    user.isSuccess &&
    (user.data.role === 'representative' || user.data.role === 'representative_with_opportunity');

  const communityAnnouncements = CommunityAnnouncements.useGetCommunityAnnouncements({
    page: 0,
    limit: 1,
    type: isRepresentative ? 'organization' : 'professional',
  });

  return (
    <div className='-my-1.5 md:px-4 md:-mt-14'>
      <div className='block md:hidden'>
        <CommunityHomeMobileBanner />
      </div>
      <div className='hidden md:block'>
        <CommunityHomeBanner />
      </div>
      <div className='flex flex-col md:flex-row gap-4 mt-4 md:gap-6 md:mt-6'>
        <div className='w-[308px] p-4 md:order-last'>
          <div className='flex flex-col gap-4'>
            {communityAnnouncements.data?.length ?
              <CommunityAnnouncementCard
                title={communityAnnouncements.data[0].title}
                description={communityAnnouncements.data[0].description}
                callToAction={communityAnnouncements.data[0].callToAction}
                link={communityAnnouncements.data[0].link ?? undefined}
              />
            : undefined}
            <div className='hidden md:block'>
              <NetworkCard />
              {isRepresentative && <AdvisorCard />}
            </div>
          </div>
        </div>
        <div className='w-[320px] md:w-[524px] flex flex-col gap-6 px-4 pb-4'>
          <CommunityWinsCarousel />
          <EventsSegment />
          {!isRepresentative && <JobPostingsSegment />}
          {isRepresentative && <FundingOpportunitySegment />}
          <div className='md:hidden flex flex-col gap-6 items-center justify-center'>
            <NetworkCard />
            {isRepresentative && <AdvisorCard />}
          </div>
        </div>
      </div>
    </div>
  );
};
